module.exports = __webpack_public_path__ + "img/menu_update.8ad52f43.svg";